module.exports = __webpack_public_path__ + "static/media/landing-health-management-icon.48322cdf.png";